import { RawConceptData } from "../../Concepts.interface";

import { MIDDLE_SCHOOL_ELA_ID } from "./getTopFiveTags";

// Explicit grade-level order for ELA section nodes.
const ELA_SECTION_ORDER = [
  "cmcxoxi9r000e3690zn040hfq", // Elementary School Language Arts
  MIDDLE_SCHOOL_ELA_ID, // Middle School Language Arts
  "cmcxoxigt000x36908dvtauxp", // High School Language Arts
];

export const sortElaItems = (
  items: Record<string, RawConceptData>,
): Record<string, RawConceptData> => {
  const rootId = Object.keys(items).find(
    (id) => (items[id] as RawConceptData).data.object_type === "Document",
  );
  if (!rootId) return items;

  const rootItem = items[rootId] as RawConceptData;
  const sortedChildren = [...rootItem.children].sort((a, b) => {
    const aOrder = ELA_SECTION_ORDER.indexOf(a);
    const bOrder = ELA_SECTION_ORDER.indexOf(b);
    return (
      (aOrder === -1 ? Infinity : aOrder) - (bOrder === -1 ? Infinity : bOrder)
    );
  });

  return { ...items, [rootId]: { ...rootItem, children: sortedChildren } };
};
